<template>
  <div>
    <div :class="$style.label">В квитанции:</div>
    <div :class="$style.title">
      <span :class="$style.muted">{{ tariff.tarifs_group.name }}</span>
      {{ tariff.name }}
    </div>

    <div :class="$style.label">В каталоге ГИС ЖКХ:</div>
    <div :class="$style.container">
      <div :class="$style.search">
        <input ref="search" v-model="search" :class="$style.searchInput" type="text" placeholder="Поиск..." />
        <app-icon :class="$style.searchIcon" name="SearchIcon" size="14px" />
        <button v-if="search" :class="$style.searchClear" @click="search=''">
          <app-icon :class="$style.searchClearIcon" name="XIcon" size="12px" />
        </button>
      </div>
      <div :class="$style.list">
        <template v-for="gisTariffGroup in list">
          <div v-show="gisTariffGroup.active" :key="gisTariffGroup.group" :class="$style.group">
            {{ gisTariffGroup.group }}
          </div>
          <div
            v-for="gisTariff in gisTariffGroup.items"
            v-show="gisTariff.active"
            :key="gisTariff.id"
            :class="[$style.item, selectedTariff === gisTariff.id && $style.itemActive]"
            @click="onSelect(gisTariff.id)"
          >
            {{ gisTariff.name }}
          </div>
        </template>
      </div>
    </div>

    <div :class="$style.footer">
      <vs-button button="submit" type="border" color="success" @click="onSubmitForm">Сохранить</vs-button>
    </div>
  </div>
</template>

<script>
import modalContext    from "@/mixins/modalContext";
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:    "gisTariffSelectPopup",
  mixins:  [modalContext, notifyHttpError],
  props:   ['tariff', 'gisTariffs', 'onSubmit'],
  data() {
    return {
      search:         '',
      list:           null,
      selectedTariff: this.tariff.gis_utility_id,
    };
  },
  methods: {
    onSelect( id ) {
      this.selectedTariff = id;
    },

    onSubmitForm() {
      if (this.isProgress) return;

      if (!this.selectedTariff) return;

      this.isProgress = true;
      this.onSubmit(this.selectedTariff).then(
        () => this.modalResolve(),
        this.notifyHttpError,
      ).finally(() => this.isProgress = false);
    },
  },
  mounted() {
    this.list = this.gisTariffs.map(( gisTariffGroup ) => ({
      ...gisTariffGroup,
      active: true,
      items:  gisTariffGroup.items.map(gisTariff => ({
        ...gisTariff,
        active: true,
      })),
    }));
    this.$refs.search.focus();
  },

  watch: {
    search( value ) {
      const search = value.toLowerCase();
      this.list.forEach(gisTariffGroup => {
        let isGroupActive = false;
        gisTariffGroup.items.forEach(( gisTariff ) => {
          const isActive = search ? gisTariff.name.toLowerCase().includes(search) : true;
          gisTariff.active = isActive;
          isGroupActive = isGroupActive || isActive;
        });
        gisTariffGroup.active = isGroupActive;
      });
    },
  },
};
</script>

<style lang="scss" module>
$border: 1px solid #d2d2d2;

.label {
  font-size: .85rem;
  color: rgba(var(--app-heading-color-light), 1);
}

.title {
  font-size: 1.15em;
  margin-bottom: 1em;
}

.muted {
  opacity: .5;
  margin-right: 1em;
}

.container {
  overflow: auto;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.footer {
  margin-top: 1em;
  text-align: center;
}

.search {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  position: relative;
}

.searchIcon {
  position: absolute;
  opacity: .3;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
}

.searchInput {
  border: 0;
  width: 100%;
  font: inherit;
  //font-size: 1.1em;
  display: block;
  padding: 5px 25px;
}

.searchClear {
  position: absolute;
  right: 12px;
  top: 9px;
  background: transparent;
  border: 0;
  border-radius: 0;
  opacity: .7;
  cursor: pointer;
  @include anim();

  &:hover {
    opacity: 1;
  }
}

.list {
  height: 350px;
  overflow: auto;
}

.group {
  margin-top: 10px;
  padding: 5px 10px;
  background: #f2f2f2;
  font-weight: 500;
  font-size: .8em;
  border-top: $border;
  border-bottom: $border;

  &:first-child {
    margin-top: 0;
    border-top: 0;
  }
}

.item {
  padding: 5px 20px;
  cursor: pointer;
  @include anim();

  &:hover, &.itemActive {
    color: #fff;
    background: color(primary);
  }
}

</style>
